<template>
  <div class="router-group">
    <div class="router-item" @click="jumpTo('/performance/orgCheck')">
      <img src="@/assets/images/home/assess.png" alt="" />
      <p>机构评估</p>
      <p>Assess Management</p>
    </div>
    <div class="router-item" @click="undone">
      <img src="@/assets/images/home/assess.png" alt="" />
      <p>俱乐部评估</p>
      <p>Assess Management</p>
    </div>
    <div class="router-item" @click="setBack('')">
      <img src="@/assets/images/home/turnback.png" alt="" />
      <p>返回主页</p>
      <p>Homepage</p>
    </div>
  </div>
</template>

<script>
import mixins from '@/views/home/mixins';
export default {
  mixins: [mixins],
  computed: {
    details() {
      const { details } = this.$route.query;
      return details;
    }
  },

  methods: {
    setBack(val) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          details: val
        }
      })
    },
    undone() {
      console.log('正在努力开发中，别催啊！！！')
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.router-group
  width 100%
  font-size 16px
  display flex
  flex-wrap wrap
  justify-content space-around
  .router-item
    background $black_color
    color $color_white
    text-align center
    display flex
    flex-direction column
    justify-content center
    align-items center
    height 200px
    margin 20px 10px
    min-width 190px
    cursor pointer
    user-select none
    &:hover
      border 2px solid $green_color
      box-shadow inset 0 0 12px $green_color
      background rgba(0, 0, 0, 0.7) url('~@/assets/images/common/hover_yioks.png') no-repeat right center
      background-size 140px 204px
    img
      width 55px
      height 55px
      margin-bottom 5px
    p
      font-size 24px
      margin-bottom 10px
      &+p
        font-size 16px
</style>
